import {Box} from "@mui/material";
import React, {useState} from "react";
import {surveyMarkdownToPlainText} from "../../shared/surveyMarkdownText.util";
import {RunnerQuestionProps} from "./runnerQuestion.types";
import {choiceSurfaceSx} from "./runnerSurface";
import ScaleLabels from "./ScaleLabels";
import {surveyControls} from "../surveyRunnerColors";

const SCALE_VALUES = Array.from({length: 10}, (_, index) => index + 1);

const SCORE_BOX_HEIGHT = 56;

function ScoreQuestion({question, localize, value, onAnswerChange}: RunnerQuestionProps) {
    const [localScore, setLocalScore] = useState<number | undefined>(undefined);
    const selected = value?.scaleValue ?? localScore;

    const pick = (score: number) => {
        setLocalScore(score);
        onAnswerChange?.({...value, scaleValue: score});
    };

    const lowLabel = localize(question.lowLabel);
    const highLabel = localize(question.highLabel);

    return (
        // The full column, so the scale lines up with the title and the other answers in Plain too.
        <Box sx={{width: '100%'}}>
            <Box
                role={'radiogroup'}
                aria-label={surveyMarkdownToPlainText(localize(question.title)) || undefined}
                sx={{
                    width: '100%',
                    display: 'grid',
                    gridTemplateColumns: {
                        xs: 'repeat(5, minmax(0, 1fr))',
                        sm: 'repeat(10, minmax(0, 1fr))',
                    },
                    gap: {xs: 0.75, sm: 1},
                }}
            >
                {SCALE_VALUES.map(score => {
                    const active = selected === score;

                    return (
                        <Box
                            key={score}
                            component={'button'}
                            type={'button'}
                            role={'radio'}
                            aria-checked={active}
                            onClick={() => pick(score)}
                            sx={theme => ({
                                ...choiceSurfaceSx(active)(theme),
                                minWidth: 0,
                                height: SCORE_BOX_HEIGHT,
                                p: 0,
                                cursor: 'pointer',
                                fontFamily: 'inherit',
                                fontSize: {xs: '1rem', sm: '1.125rem'},
                                fontWeight: 600,
                                lineHeight: 1.25,
                                color: active ? surveyControls(theme).accent : theme.palette.text.primary,
                            })}
                        >
                            {score}
                        </Box>
                    );
                })}
            </Box>

            <ScaleLabels lowLabel={lowLabel} highLabel={highLabel} mobileEndpoints={[1, 10]}/>
        </Box>
    );
}

export default ScoreQuestion;
